
let events =  {
    STAGE_CREATED : "STAGE_CREATED",
    STAGES_FETCHED: "STAGES_FETCHED",
    STAGE_DELETED: "STAGE_DELETED",
    STAGE_SELECTED: "STAGE_SELECTED",
    STAGE_UPDATED: "STAGE_UPDATED",
    TRANSITION_SELECTED: "TRANSITION_SELECTED",
    TRANSITION_CREATED: "TRANSITION_CREATED",
    TRANSITIONS_FETCHED: "TRANSITIONS_FETCHED",
    TRANSITION_UPDATED: "TRANSITION_UPDATED",
    TRANSITION_DELETED: "TRANSITION_DELETED",
    WEBHOOK_CREATED: "WEBHOOK_CREATED",
    PLANTILLA_ID_CHANGED: "PLANTILLA_ID_CHANGED",

    RESPUESTAS_FETCHED: "RESPUESTAS_FETCHED",
    RESPUESTA_CREATED: "RESPUESTA_CREATED",
    RESPUESTA_UPDATED: "RESPUESTA_UPDATED",
    RESPUESTA_DELETED: "RESPUESTA_DELETED",


}


export default events;